/* RESPONSIBLE TEAM: team-standalone */
import Platform from './platform';
import { IntegrationState, StandalonePlatform } from '../constants';
import type FreshdeskConfiguration from 'embercom/models/standalone/freshdesk-configuration';
import type ApplicationInstance from '@ember/application/instance';
import FreshdeskLegacyConversationExtractionRow from './component-data/freshdesk-legacy/conversation-extraction-row';
import FreshdeskLegacyConversationExcerpt from './component-data/freshdesk-legacy/conversation-excerpt';
import GenericOnboardingGuideStep from './component-data/generic/onboarding-guide-step';
import GenericRequestAccessData from './component-data/generic/request-access';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

// Old, pre generic platform Tickets only Freshdesk.
export default class FreshdeskLegacyPlatform extends Platform {
  @service declare store: Store;
  @service declare appService: AppService;

  freshdeskConfig?: FreshdeskConfiguration;

  constructor(owner: ApplicationInstance, inputs: { freshdeskConfig?: FreshdeskConfiguration }) {
    super(owner);
    this.freshdeskConfig = inputs.freshdeskConfig;
  }

  get componentData(): Platform['componentData'] {
    return {
      'conversation-extraction': FreshdeskLegacyConversationExtractionRow,
      'conversation-excerpt': new FreshdeskLegacyConversationExcerpt(this),
      'knowledge-hub-modal': null,
      'onboarding-guide-step': new GenericOnboardingGuideStep(this),
      'request-access': new GenericRequestAccessData(this),
    } as const;
  }

  async loadConfigData() {
    this.freshdeskConfig = await this.store.findRecord(
      'standalone/freshdesk-configuration',
      this.appService.app.id,
    );
  }

  async loadRequiredData() {
    // TODO
  }

  async loadDataFields() {
    // TODO
  }

  get isConnected() {
    return this.freshdeskConfig?.isConnected || false;
  }

  get hasInstalledCopilot() {
    return false;
  }

  get historicalSyncingEnabled() {
    return false;
  }

  get finIsLive() {
    return this.freshdeskConfig?.isEnabledForTickets || false;
  }

  get finIsPaused() {
    return this.freshdeskConfig?.isPausedForTickets || false;
  }

  get showAnalyzeSectionConnectCta() {
    return false;
  }

  get connectionState() {
    return this.freshdeskConfig?.ticketState ?? IntegrationState.NotConfigured;
  }

  get icon() {
    return 'conversation' as const;
  }

  get platformKey() {
    return StandalonePlatform.Freshdesk;
  }

  get supportsFinPlayground() {
    return false;
  }

  get supportsConversationSyncing() {
    return false;
  }

  findMappedConversationField(_id: string | undefined) {
    return undefined;
  }

  isMappedUserAttribute(_attributeIdentifier: string) {
    return false;
  }

  isMappedCompanyAttribute(_attributeIdentifier: string) {
    return false;
  }

  isMappedConversationAttribute(_attributeIdentifier: string) {
    return false;
  }

  get ticketFields() {
    return [];
  }

  get userFields() {
    return [];
  }

  get organizationFields() {
    return [];
  }
}
